import React from 'react';

const iconStyle = { color: '#51a2ff' };
const svgProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '17.5',
  height: '17.5',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '2',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true'
};

export function footerContactIconForType(iconType) {
  const t = String(iconType || '').toLowerCase();
  if (t === 'address' || t === 'map-pin' || t === 'map_pin') {
    return (
      <svg
        {...svgProps}
        style={iconStyle}
        className="lucide lucide-map-pin h-5 w-5 text-blue-400 dark:text-blue-300 mt-0.5 flex-shrink-0 group-hover:text-blue-300 dark:group-hover:text-blue-200 transition-colors"
      >
        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    );
  }
  if (t === 'phone') {
    return (
      <svg
        {...svgProps}
        style={iconStyle}
        className="lucide lucide-phone h-5 w-5 text-blue-400 dark:text-blue-300 flex-shrink-0 group-hover:text-blue-300 dark:group-hover:text-blue-200 transition-colors"
      >
        <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
      </svg>
    );
  }
  if (t === 'e-mail' || t === 'email' || t === 'mail') {
    return (
      <svg
        {...svgProps}
        style={iconStyle}
        className="lucide lucide-mail h-5 w-5 text-blue-400 dark:text-blue-300 flex-shrink-0 group-hover:text-blue-300 dark:group-hover:text-blue-200 transition-colors"
      >
        <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
        <rect x="2" y="4" width="20" height="16" rx="2" />
      </svg>
    );
  }
  if (t === 'hours' || t === 'clock') {
    return (
      <svg
        {...svgProps}
        style={iconStyle}
        className="lucide lucide-clock h-5 w-5 text-blue-400 dark:text-blue-300 flex-shrink-0 group-hover:text-blue-300 dark:group-hover:text-blue-200 transition-colors"
      >
        <path d="M12 6v6l4 2" />
        <circle cx="12" cy="12" r="10" />
      </svg>
    );
  }
  return null;
}

/**
 * DB/API contact 블록에 아이콘 JSX 부착 (Footer.jsx 기본 SVG와 동일)
 */
export function attachFooterContactIcons(contact) {
  if (!contact?.items?.length) return contact;
  return {
    ...contact,
    items: contact.items.map((item) => {
      const key = item.iconType || item.type || 'phone';
      const icon = footerContactIconForType(key);
      return { ...item, icon };
    })
  };
}
